<template>
  <b-overlay
    :show="loader.planEstudios"
    opacity="0.50"
    rounded="sm"
  >
    <label for="concepto">Concepto de Aportacion <b class="text-danger">*</b></label>
    <v-select
      :value="concepto"
      :options="listaConceptos"
      :disabled="disabled"
      label="concepto"
      placeholder="Selecciona"
      :clearable="false"
      @input="(val) => $emit('selectedtipo', val)"
    >
      <template #no-options>
        Inhabilitado por el momento.
      </template>
    </v-select>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
    BOverlay,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    conceptop: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    const loader = ref(false)
    const concepto = ref(null)
    const listaConceptos = ref([])
    const toast = useToast()
    const getConceptos = q => {
      loader.value = true
      getData({ action: 12, token: store.state.cuenta.session.token, q }, 'wsplanEstudios')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) listaConceptos.value = response.data?.data
          else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status}`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }).catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error, No hay conexión',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        }).finally(() => {
          loader.value = false
        })
    }
    onMounted(() => { getConceptos() })

    watch(() => props.conceptop,
      value => {
        concepto.value = value
        emit('selectedtipo', value)
      },
      { immediate: true })

    return {
      concepto,
      loader,
      listaConceptos,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
